import CommunicationChannelForm from './CommunicationChannelForm';
import CommunicationTimeline from './CommunicationTimeline';

// Domain\EmployeeCommunications\Enums\State::QUEUED
const QUEUED = 1;

const CommunicationSection = ({ communication, emptyText }) => {
    if (!communication) {
        return <p className='text-sm text-gray-500'>{emptyText}</p>;
    }

    return (
        <>
            <CommunicationTimeline communication={communication} />

            {communication.state === QUEUED && (
                <CommunicationChannelForm communication={communication} />
            )}
        </>
    );
};

export default CommunicationSection;
